<div class="card" style="height: auto !important">
  <!-- Header -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
     Create a CapitalPortal Access Report
    </h3>
  </div>
    <!-- Card Body -->
  <div class="p-4">
    <!-- Form Controls in a properly spaced layout -->
    <div class="flex flex-col space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Start Date</label>
        <kendo-datepicker
          [(ngModel)]="ngModelDate"
          placeholder="Start Date"
          format="MM/dd/yyyy"
          [size]="'small'"
          style="width: 300px;"
        >
        </kendo-datepicker>
      </div>
      
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">End Date</label>
        <kendo-datepicker
          [(ngModel)]="ngModelendDate"
          placeholder="End Date"
          format="MM/dd/yyyy"
          [size]="'small'"
          style="width: 300px;"
        >
        </kendo-datepicker>
      </div>
      
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Report Type</label>
        <kendo-dropdownlist
          [data]="[
            { text: 'All Transactions', value: '1' },
            { text: 'Non-Rep Entered Transactions', value: '2' },
            { text: 'Summary of Non-Rep Entered Transactions', value: '3' },
            { text: 'ALL Transactions Short', value: '4' }
          ]"
          textField="text"
          valueField="value"
          [(ngModel)]="selectedItem"
          placeholder="Report Type"
          style="width: 300px;"
        >
        </kendo-dropdownlist>
      </div>

      <!-- Create a new row for the button with proper spacing -->
      <div class="pt-4">
        <button
          type="button"
          class="k-button k-primary"
          [ngClass]="buttonState"
          style="width: 200px; padding: 8px 16px;"
          (mouseenter)="onMouseEnter()"
          (mouseleave)="onMouseLeave()"
          (click)="ExportToExcel(excelexport)"
        >
          Export To Excel
        </button>
      </div>
    </div>

    <!-- Hidden Excel Export Component -->
    <kendo-excelexport
      [data]="gridExcelexport"
      [collapsible]="true"
      fileName="AccessExport.xlsx"
      #excelexport
    >
      <kendo-excelexport-column
        field="loginLogId"
        [hidden]="true"
        [locked]="true"
        title="LoginLogId"
        [width]="200"
      >
      </kendo-excelexport-column>
      <kendo-excelexport-column
        field="userName"
        title="UserName"
        [width]="350"
      >
      </kendo-excelexport-column>
      <kendo-excelexport-column
        field="loginDate"
        title="LoginDate"
        [width]="120"
      >
      </kendo-excelexport-column>
      <kendo-excelexport-column
        field="logoutDate"
        title="LogoutDate"
        [width]="120"
      >
      </kendo-excelexport-column>
      <kendo-excelexport-column
        field="ipaddress"
        title="Ipaddress"
        [hidden]="true"
        [locked]="true"
        [width]="120"
      >
      </kendo-excelexport-column>
    </kendo-excelexport>
  </div>
</div>